<p-floatLabel>
  <p-select #integrationStateDropdown
        id="integrationStateDropdown"
        name="integrationStateDropdown"
        [options]="integrationStates"
        [(ngModel)]="selectedIntegrationState"
        [showClear]="true"
        [checkmark]="true"
        [filter]="true"
        styleClass="w-100"
        [disabled]="isDisabled"
        (onChange)="onSelected()"
        optionLabel="label">
    <ng-template let-option pTemplate="item">
      {{ option?.label }}
    </ng-template>
  </p-select>
  <label for="integrationStateDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::IntegrationState') }}
    </app-label-content>
  </label>
</p-floatLabel>